export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8681.16c5b47c.jpg";